import React from 'react';
import Container from 'react-bootstrap/Container';
import { useTranslation } from 'react-i18next';

import '../style/heroSection.css';

function HeroSection() {
    const { t } = useTranslation();

    return (
        <section className="hero-section">
            <Container>
                <div className="hero-content">
                    <h1 className="hero-catchphrase">{t('hero.catchphrase')}</h1>
                    <p className="hero-subheading">{t('hero.subheading')}</p>
                </div>
            </Container>
        </section>
    );
}

export default HeroSection;
